<template>
  <div>
    <v-col offset-md="3" :md="6">
      <h1 class="text-center primary--text">Enter Tournament Results</h1>
      <div v-if="gameEntry">
        <v-select v-model="tourId" @change="tourChange"
          :items="ownTourList" item-text="tournamentName" item-value="tournamentId"
          label="Select Tournament">
        </v-select>
        <div v-if="tourObject && (tourObject.tournamentType == 'L' || tourObject.tournamentType == 'B')">
          <h2 class="text-center primary--text">Game Results</h2>
          <h4 class="text-center primary--text">(Click/Touch on the team that won)</h4>
          <v-card v-for="(item, index) in resultList" :key="index" class="my-3 py-2">
            <v-row class="mx-5">
              Game #{{ index + 1 }}
              <v-spacer></v-spacer>
              On {{ convDate(item.gameDate) }} @ {{ item.gameVenue }}
            </v-row>
            <v-row class="mx-10">
              <v-card class="text-center py-2 px-2" 
                :class="[ (item.gameResult == 'A' || item.gameResult == 'X') ? 'primary' : '' ]"
                @click="selectTeam(index, 'A')">
                {{ item.memberA }} ({{ item.oddA }})
              </v-card>
              <v-spacer></v-spacer>
              <v-card class="text-center py-2 px-2" 
                :class="[ (item.gameResult == 'B' || item.gameResult == 'X') ? 'primary' : '' ]"
                @click="selectTeam(index, 'B')">
                {{ item.memberB }} ({{ item.oddB }})
              </v-card>
            </v-row>
            <div class="mx-16"  v-for="(bon, bIndex) in bonusPointList" :key="bon.bonusId">
                <v-select v-model="item.bonusResult[bIndex].result"
                  :items="bon.possOutcomes" :label="bon.bonusName"
                  class="mx-16 mb-n3"
                >
                </v-select>
            </div>
          </v-card>
        </div>
        <div v-else-if="tourObject">
          <h4 class="text-center primary--text">Click on Next</h4>
        </div>
        <v-row v-if="tourObject" class="my-6 mx-2">
          <v-btn color="success" outlined @click="goBack">Cancel</v-btn>
          <v-spacer></v-spacer>
          <v-btn color="primary" outlined @click="saveGames">Save</v-btn>
          <v-spacer></v-spacer>
          <v-btn color="primary" outlined @click="gameNext">Next</v-btn>
        </v-row>
      </div>
      <div v-else>
        <h2 class="text-center primary--text my-3">Enter Tournament Knockout Qualifiers</h2>
        <h2 class="text-center primary--text">{{ tourObject.tournamentName }}</h2>
        <h3 class="text-center primary--text">Choose {{ koValues[koIndex] }}</h3>
        <h3 class="text-center primary--text">{{ koQList.length }} out of {{ koNumbers[koIndex] }} chosen</h3>
        <v-card v-for="item in tourGroups[0].groupMembers" 
          :key="item" class="text-center my-4 mx-10 py-2"
          :class="selectedQual(item) ? 'primary': ''"
          @click="selectQual(item)"
        >
          {{ item }}
        </v-card>
        <v-row>
          <v-btn color="primary" @click="prevQual" outlined>Prev</v-btn>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="saveQual" outlined>Save</v-btn>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="nextQual" outlined>Next</v-btn>
        </v-row>
      </div>
      <v-row class="my-5">
        <v-spacer></v-spacer>
        <v-btn color="primary" outlined @click="calcPoints">Calculate Points</v-btn>
        <v-spacer></v-spacer>
      </v-row>
    </v-col>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import axios from 'axios'

export default {
  name: 'result-entry',
  computed: {
    ...mapGetters([
      'ownTourList', 'gameResult', 'resultLoaded',
      'bonusPointList', 'groupGames', 'groupGamesLoaded',
      'tourGroups', 'bonusPointLoaded', 'koQualifiers'
    ]),
  },
  watch: {
    resultLoaded: function() {
      var i = 0
      if (this.gameResult.length > 0) {
        this.resultList.splice(0)
        for (i=0; i<this.gameResult.length; i++) {
          let result = {
            gameId: this.gameResult[i].gameId,
            gameDate: this.gameResult[i].gameDate,
            gameVenue: this.gameResult[i].gameVenue,
            gameNum: this.gameResult[i].gameNum,
            memberA: this.gameResult[i].memberA,
            memberB: this.gameResult[i].memberB,
            oddA: this.gameResult[i].oddA,
            oddB: this.gameResult[i].oddB,
            gameResult: this.gameResult[i].gameResult,
            bonusResult: this.gameResult[i].bonusResult.slice()
          }
          this.resultList.push(result)
        }
      } else {
        return
      }
    },
    groupGamesLoaded: function() {
      //if (oldval == true && newval == false) { return }
      if (this.gameResult.length > 0) {
        return
      }
      if (this.groupGames.length > 0) {
        this.resultList.splice(0)
        for (let i = 0; i<this.groupGames.length; i++) {
          let result = {
            gameId: this.groupGames[i].gameId,
            gameDate: this.groupGames[i].gameDate,
            gameVenue: this.groupGames[i].gameVenue,
            gameNum: this.groupGames[i].gameNum,
            memberA: this.groupGames[i].memberA,
            memberB: this.groupGames[i].memberB,
            oddA: this.groupGames[i].oddA,
            oddB: this.groupGames[i].oddB,
            gameResult: ' ',
            bonusResult: []
          }
          var j = 0
          //while (!this.bonusPointLoaded);
          for (j=0; j<this.bonusPointList.length; j++) {
            var bonus = {
              bonusId: this.bonusPointList[j].bonusId,
              result: ' '
            }
            result.bonusResult.push(bonus)
          }
          this.resultList.push(result)
        }
      }
    }
  },
  data: () => ({
    gameEntry: true,
    tourObject: null,
    tourId: '',
    resultList: [],
    koNumbers: [1, 2, 4, 8, 16, 32, 64, 128, 256],
    koValues: ['Winner', 'Finalists', 'Semi-Finalists', 'Quarter-Finalists', 
              'Round of 16', 'Round of 32', 'Round of 64', 'Round of 128', 'Round of 256'],
    koIndex: -1,
    koQList: [],
    entryChanged: false,
  }),
  created() {
    this.$store.dispatch('getOwnTourList')
  },
  methods: {
    convDate(inDate) {
      return inDate.substring(0, 10)
    },
    checkForChanges() {
      if (this.entryChanged) {
        return (confirm("Changes have been made.  Do you want to move without saving?"))
      } else {
        return true
      }
    },
    tourChange() {
      this.tourObject = this.ownTourList.find(elem => elem.tournamentId == this.tourId)
      this.$store.dispatch('getBonusPointList', this.tourObject.sportId)
      this.$store.dispatch('getGameResult', this.tourObject.tournamentId)
      this.$store.dispatch('getGroupGamesByTour', this.tourObject.tournamentId)
      this.$store.dispatch('getTourGroups', this.tourObject.tournamentId)
      this.$store.dispatch('getKOQualifiers', this.tourObject.tournamentId)
      this.koIndex = Math.log2(this.tourObject.knockoutStartLevel)
    },
    selectTeam(index, team) {
      this.entryChanged = true
      if (this.resultList[index].gameResult == ' ') {
        this.resultList[index].gameResult = team
      } else if (this.resultList[index].gameResult == 'X') {
        this.resultList[index].gameResult = (team == 'A') ? 'B' : 'A'
      } else {
        if (team != this.resultList[index].gameResult) {
          this.resultList[index].gameResult = 'X'
        } else {
          this.resultList[index].gameResult = ' '
        }
      }
    },
    goBack() {
      if (!this.checkForChanges()) {
        return
      }
      this.$router.go(-1)
    },
    saveGames() {
      const token = this.$store.getters.authToken
      const header = { 'Content-Type': 'application/json', 'x-auth': token }
      var i = 0
      for (i=0; i<this.resultList.length; i++) {
        var resultObj = {
          tournamentId: this.tourObject.tournamentId,
          gameId: this.resultList[i].gameId,
          gameResult: this.resultList[i].gameResult,
          bonusResult: this.resultList[i].bonusResult
        }
        axios.post('/api/groupGameResult', JSON.stringify(resultObj), { headers: header })
        .catch(error => {
          alert(error.response.data.err)
        })
      }
      this.entryChanged = false
      this.$store.dispatch('getGameResult', this.tourObject.tournamentId)
    },
    setupQList() {
      this.koQList.splice(0)
      if (this.koQualifiers.length > 0) {
        let index = this.koQualifiers.findIndex(elem => elem.koLevel == this.koNumbers[this.koIndex])
        if (index >= 0) {
          this.koQList = this.koQualifiers[index].qualifiers.slice(0)
        } 
      }
    },
    gameNext() {
      if (!this.checkForChanges()) {
        return
      }
      this.koQList.splice(0)
      this.koIndex = Math.log2(this.tourObject.knockoutStartLevel)
      this.setupQList()
      this.entryChanged = false
      this.gameEntry = false
    },
    selectedQual(team) {
      let found =  this.koQList.findIndex(elem => elem == team )
      return (found == -1) ? false : true
    },
    selectQual(team) {
      let index = this.koQList.findIndex(elem => elem == team)
      if (index == -1) {
        if (this.koQList.length == this.koNumbers[this.koIndex]) {
          return
        }
        this.koQList.push(team)
      } else {
        this.koQList.splice(index, 1)
      }
      this.entryChanged = true
    },
    prevQual() {
      if (!this.checkForChanges()) {
        return
      }
      if (this.koNumbers[this.koIndex] == this.tourObject.knockoutStartLevel) {
        this.gameEntry = true
      }
      this.entryChanged = false
      this.koIndex = this.koIndex + 1
      this.setupQList()
    },
    saveQual() {
      const token = this.$store.getters.authToken
      const header = { 'Content-Type': 'application/json', 'x-auth': token }
      var qObj = {
        tournamentId: this.tourObject.tournamentId,
        koLevel: this.koNumbers[this.koIndex],
        qualifiers: this.koQList
      }
      axios.post('/api/knockoutQualifier', JSON.stringify(qObj), { headers: header })
      .then(() => {
        this.$store.dispatch('getKOQualifiers', this.tourObject.tournamentId)
      })
      .catch(error => {
        alert(error.response.data.err)
        return
      })
      this.entryChanged = false
    },
    nextQual() {
      if (!this.checkForChanges()) {
        return
      }
      if (this.koIndex == 0) {
        return
      }
      this.entryChanged = false
      this.koIndex = this.koIndex - 1
      this.setupQList()
    },
    calcPoints() {
      const token = this.$store.getters.authToken
      const header = { 'Content-Type': 'application/json', 'x-auth': token }
      var passObj = {
        tourId: this.tourId
      }
      axios.post('/api/calcPoolPoints', JSON.stringify(passObj), { headers: header })
      .then(() => {
        alert('Points Calculated')
      })
      .catch(err => {
        alert(err.response.data.err)
      })
    }
  }
}
</script>